/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum AlertsCreateNewInputEnum {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
    ACTIVE = 'ACTIVE',
    SCHEDULE_STARTS_ON = 'SCHEDULE_STARTS_ON',
    SCHEDULE_ENDS_ON = 'SCHEDULE_ENDS_ON'
}
